import { printWithTheme } from "../utils/typography";
import { englishError } from "../utils/databaseErrors";
// src/components/SalesTable.jsx
import React, { useEffect, useState, useRef } from "react";
import { supabase } from "../supabaseClient";
import "./SalesTable.css";
import logo from "../assets/PdfImagetrs.png";
import ReturnNoteModal from "./ReturnNoteModal";
import { fetchReturnsForShowroom, getReturnNoteById } from "./returns";
import { availableQuantity, businessDate, PRODUCT_TYPES, reservationStatus, saleStockForecast, stockCountLabel, stockCountUnit, validateSaleStock } from "../utils/stock";
import { saleDateError } from "../utils/saleDate";
import { validMarbleQuantity, roundQuantity, sumQuantities } from "../utils/marbleQuantity";
import { calculateSaleRow, saleSizeItems, saleSizeLabel, saleSizeTotals, validateSaleSizes } from "../utils/saleSizes";

const TREAT_MAP = { epoxy: "Epoxy", resin: "Resin", none: "None" };

/* ---------- ستايل الطباعة (كما هو) ---------- */
if (typeof window !== "undefined" && document) {
  if (!document.getElementById("print-style")) {
    const style = document.createElement("style");
    style.id = "print-style";
    style.innerHTML = `
@media print {
  html, body { height: auto; }
  body * { visibility: hidden !important; }
  #printable-invoice, #printable-invoice * { visibility: visible !important; }
  #printable-invoice {
    position: static !important;
    width: 190mm !important;
    max-width: 190mm !important;
    margin: 0 auto !important;
    padding: 10mm !important;
    box-shadow: none !important;
    background: #faf8f4 !important;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  #printable-invoice button, .no-print { display: none !important; }
}
@page { size: A4 portrait; margin: 10mm; }
`;
    document.head.appendChild(style);
  }
}

/* ---------- دوال مساعدة للهاتف ---------- */
function normalizePhone(p) {
  if (!p) return "";
  const digits = String(p).replace(/[^\d+]+/g, "");
  return digits.startsWith("00") ? "+" + digits.slice(2) : digits;
}

/* ---------- مودال طباعة الفاتورة (كما هو) ---------- */
function InvoiceModal({ open, onClose, invoice, user }) {
  if (!open || !invoice) return null;
  const { sale, saleDetails, customer, payments } = invoice;
  const totalPaid = payments.reduce((a, p) => a + Number(p.amount), 0);
  const gross = saleDetails.reduce((a, d) => a + Number(d.total_price || 0), 0);
  const discount = Number(invoice.sale?.discount_amount || 0);
  const net = Number(invoice.sale?.net_total ?? (gross - discount));
  const remaining = net - totalPaid;
  const totalSlabsInInvoice = roundQuantity(saleDetails.reduce((a, d) => a + Number(d.slabs_sold || 0), 0));
  const totalAreaInInvoice  = saleDetails.reduce((a, d) => a + Number(d.area_sold   || 0), 0);

  function handlePrintInvoice() {
    const rowsHtml = (saleDetails || []).map(d => `
      <tr>
        <td>${d.block_code || ""}</td>
        <td>${d.material_name || "-"}</td>
        <td>${Number(d.slabs_sold || 0)}</td>
        <td>${saleSizeLabel(d.width,d.height)}</td>
        <td>${Number(d.area_sold || 0).toFixed(3)}</td>
        <td>${Number(d.price_per_m2 || 0).toFixed(2)}</td>
        <td>${Number(d.total_price || 0).toFixed(2)}</td>
      </tr>
    `).join("");

    const html = `
      <html dir="ltr" lang="ar">
        <head>
          <meta charset="utf-8" />
          <title>Sales invoice #${sale.id || ""}</title>
          <style>
            @page { size: A4 portrait; margin: 10mm; }
            body { font-family: Jost, 'Trebuchet MS', Arial, sans-serif; margin:0; padding:0; background:#faf8f4; }
            .wrap { width:190mm; margin:0 auto; padding:10mm; box-sizing:border-box; }
            h2 { text-align:center; color:var(--accent, #514536); margin:0 0 10px; }
            table { width:100%; border-collapse:collapse; margin-top:10px; }
            th, td { border:1px solid #d2cbc1; padding:6px 8px; text-align:center; }
            thead tr { background:#d2cbc1; }
            .totals { margin-top:10px; font-weight:bold; color:var(--accent, #514536); }
            .thanks { text-align:center; margin-top:16px; color:#514536; }
            .policy { text-align:center; margin-top:16px; font-weight:bold; }
            img.logo { width:110px; display:block; margin:0 auto 12px; }
          </style>
        </head>
        <body>
          <div class="wrap">
            <img class="logo" src="${logo}" alt="Logo" />
            <h2>Sales invoice</h2>
            <div><b>Customer:</b> ${customer?.name || ""}</div>
            <div><b>Date:</b> ${sale?.date ? sale.date.split("T")[0] : ""}</div>
            <div><b>Sales representative:</b> ${user?.name || ""}</div>

            <table>
              <thead>
                <tr>
                  <th>Product code</th>
                  <th>Product type</th>
                  <th>Quantity</th>
                  <th>Size (L × W)</th>
                  <th>Area</th>
                  <th>Price per m²</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                ${rowsHtml}
              </tbody>
            </table>

            <div class="totals">
              Total pieces: ${totalSlabsInInvoice} pieces<br/>
              Total area: ${totalAreaInInvoice.toFixed(3)} m²
            </div>

            <div style="margin-top:10px;">
              <div><b>Total before discount:</b> ${gross} EGP</div>
              ${discount > 0 ? `<div><b>Discount:</b> -${discount} EGP</div>` : ""}
              <div><b>Total after discount:</b> ${net} EGP</div>
              <div><b>Balance due:</b> ${remaining} EGP</div>
            </div>

            <div class="thanks">Thank you for choosing Abbas Halim Marble and Granite</div>
            <div class="policy">* The customer is responsible for selecting colours and quantities. Returns and exchanges are not accepted</div>
          </div>
        </body>
      </html>
    `;
    const win = window.open("", "_blank");
    if (win && win.document) {
      win.document.open();
      win.document.write(html);
      win.document.close();
      printWithTheme(win);
      win.focus();
    }
  }

  const thSt = { padding: 8, border: "1px solid #d2cbc1", fontWeight: "bold", fontSize: 15, textAlign: "left", direction: "ltr" };
  const tdSt = { padding: 8, border: "1px solid #d2cbc1", fontSize: 15, textAlign: "left", direction: "ltr" };
  const printBtnSt = { background: "var(--accent, #514536)", color: "#faf8f4", padding: "8px 30px", borderRadius: 8, fontWeight: "bold", fontSize: 17, border: "none" };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#51453644", zIndex: 2002, display: "flex", alignItems: "center", justifyContent: "center", overflow: "auto", padding: 20 }}>
      <div id="printable-invoice" className="ms-invoice-modal" style={{ background: "#faf8f4", borderRadius: 15, minWidth: 500, minHeight: 150, padding: "40px 60px 10px", direction: "ltr", fontFamily: "Jost, 'Trebuchet MS', Arial, sans-serif", overflow: "auto", boxSizing: "border-box" }}>
        <div style={{ width: "50%", display: "flex", alignItems: "center", marginBottom: -6 }}>
          <img src={logo} alt="logo" style={{ width: 110, marginLeft: "auto", display: "block" }} />
        </div>
        <h2 style={{ textAlign: "center", color: "var(--accent, #514536)" }}>
          <br /><br /><br /> Sales invoice
        </h2>
        <div style={{ marginBottom: 10 }}>
          <b>Customer:</b> {customer?.name || ""} <br />
          <b>Date:</b> {sale?.date ? sale.date.split("T")[0] : ""}
        </div>
        <div style={{ marginBottom: 10 }}>
          <b>Sales representative:</b> {user?.name || ""}
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 16, direction: "ltr", textAlign: "left" }}>
          <thead>
            <tr style={{ background: "#d2cbc1" }}>
              <th style={thSt}>Product code</th>
              <th style={thSt}>Product type</th>
              <th style={thSt}>Quantity</th>
              <th style={thSt}>Size (L × W)</th>
              <th style={thSt}>Area</th>
              <th style={thSt}>Price per m²</th>
              <th style={thSt}>Total</th>
            </tr>
          </thead>
          <tbody>
            {saleDetails.map((d, i) => (
              <tr key={i}>
                <td style={tdSt}>{d.block_code}</td>
                <td style={tdSt}>{d.material_name}</td>
                <td style={tdSt}>{d.slabs_sold}</td>
                <td style={tdSt}>{saleSizeLabel(d.width,d.height)}</td>
                <td style={tdSt}>{d.area_sold}</td>
                <td style={tdSt}>{d.price_per_m2}</td>
                <td style={tdSt}>{d.total_price}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ marginTop: 8, marginBottom: 12, fontWeight: "bold", color: "var(--accent, #514536)", textAlign: "left" }}>
          Total pieces: {totalSlabsInInvoice.toLocaleString()} pieces
          <br />
          Total area: {totalAreaInInvoice.toLocaleString(undefined, { maximumFractionDigits: 3 })} m²
        </div>

        <div style={{ marginBottom: 12 }}>
          <div><b>Total before discount:</b> {gross.toLocaleString()} EGP</div>
          {discount > 0 && (<div><b>Discount:</b> -{discount.toLocaleString()} EGP</div>)}
          <div><b>Total after discount:</b> {net.toLocaleString()} EGP</div>
        </div>

        <div style={{ marginBottom: 6 }}>
          <b>Payments:</b>
          <ul style={{ margin: 0, padding: 0, paddingRight: 16 }}>
            {payments.map((p, i) => (
              <li key={i} style={{ fontSize: 15 }}>
                {p.payment_date?.split("T")[0]} — {Number(p.amount).toLocaleString()} EGP
                {p.notes && <> ({p.notes})</>}
              </li>
            ))}
          </ul>
          <b>Balance due: </b>{remaining.toLocaleString()} EGP
        </div>

        <div style={{ textAlign: "center", color: "#514536", marginTop: 18 }}>
          <br />Thank you for choosing Abbas Halim Marble and Granite
        </div>
        <div style={{ textAlign: "center", color: "#514536", marginTop: 28, fontWeight: "bold" }}>
          *The customer is responsible for selecting colours and quantities. Returns and exchanges are not accepted
        </div>
        <div style={{ display: "flex", gap: 16, marginTop: 20, justifyContent: "center" }}>
          <button className="no-print" onClick={handlePrintInvoice} style={printBtnSt}>Print</button>
          <button className="no-print" onClick={onClose} style={{ background: "#d2cbc1", padding: "8px 30px", borderRadius: 8 }}>Close</button>
        </div>
      </div>
    </div>
  );
}

/* ---------- بوب-أب إضافة عميل (تم جعله يُلزم الهاتف، ويمنع التكرار) ---------- */
function SmallAddCustomerPopup({ onSaved, onClose, initialPhone = "" }) {
  const [form, setForm] = useState({
    name: "",
    phone: initialPhone,
    email: "",
    roles: ["عميل"],
  });
  const [busy, setBusy] = useState(false);

  async function handleAdd() {
    if (!form.name) return alert("Customer name is required");
    if (!form.phone) return alert("Phone number is required");

    setBusy(true);
    try {
      const phoneNorm = normalizePhone(form.phone);

      // تحقّق من التكرار
      const { data: dup } = await supabase
        .from("customer")
        .select("id,name,phone")
        .neq("phone", null)
        .neq("phone", "")
        .or(`phone.eq.${phoneNorm},phone.eq.${form.phone}`);

      const hit = (dup || []).find(
        (c) => normalizePhone(c.phone) === phoneNorm
      );
      if (hit) {
        alert(`This customer already exists: ${hit.name} (ID ${hit.id})`);
        setBusy(false);
        return;
      }

      await supabase.from("customer").insert([{
        name: form.name,
        phone: phoneNorm,
        email: form.email || null,
        roles: form.roles,
      }]);

      onSaved && onSaved();
      onClose();
    } catch (e) {
      alert(englishError(e.message) || "Unable to save customer");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "#51453610", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 2500 }}>
      <div className="ms-small-modal" style={{ background: "#faf8f4", padding: 28, borderRadius: 12, minWidth: 340, textAlign: "left", direction: "ltr" }}>
        <h4 style={{ marginTop: 0 }}>Add customer</h4>
        <input
          placeholder="Customer name"
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          style={{ width: "100%", marginBottom: 10, padding: 6 }}
        />
        <input
          placeholder="Phone number (Required)"
          value={form.phone}
          onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
          style={{ width: "100%", marginBottom: 10, padding: 6 }}
        />
        <input
          placeholder="Email address"
          value={form.email}
          onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          style={{ width: "100%", marginBottom: 10, padding: 6 }}
        />

        <div style={{ display: "flex", gap: 16, marginBottom: 10 }}>
          <label>
            <input
              type="checkbox"
              checked={form.roles.includes("عميل")}
              onChange={(e) => setForm((f) => {
                let roles = f.roles.filter((r) => r !== "عميل");
                if (e.target.checked) roles.push("عميل");
                return { ...f, roles };
              })}
            /> Customer
          </label>
          <label>
            <input
              type="checkbox"
              checked={form.roles.includes("مورد")}
              onChange={(e) => setForm((f) => {
                let roles = f.roles.filter((r) => r !== "مورد");
                if (e.target.checked) roles.push("مورد");
                return { ...f, roles };
              })}
            /> Supplier
          </label>
        </div>

        <button onClick={handleAdd} disabled={busy} style={{ background: "var(--accent, #514536)", color: "#faf8f4", padding: "8px 16px", borderRadius: 8, fontWeight: "bold" }}>
          {busy ? "Saving..." : "Save"}
        </button>
        <button onClick={onClose} disabled={busy} style={{ background: "#d2cbc1", marginRight: 8, padding: "8px 16px", borderRadius: 8 }}>
          Cancel
        </button>
      </div>
    </div>
  );
}

/* ====================== الكومبوننت الرئيسي ====================== */
function SalesTable({ user, formOnly = false, initialDate, onSaleSaved, onCancel }) {
  const [sales, setSales] = useState([]);
  const [saleDetails, setSaleDetails] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [blockDistributions, setBlockDistributions] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [showAddCustomer, setShowAddCustomer] = useState(false);
  const [showForm, setShowForm] = useState(formOnly);
  const [returns, setReturns] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [reservationId, setReservationId] = useState("");
  const [stockError, setStockError] = useState("");
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);

  // 🔎 جديد: إدخال/بحث بالهاتف داخل فورم البيع
  const [phoneSearch, setPhoneSearch] = useState("");
  const [matchedCustomer, setMatchedCustomer] = useState(null);

  // فورم البيع
  const [form, setForm] = useState(() => ({
    customer_id: "",
    date: initialDate || businessDate(),
    rows: [
      { material_id: "", block_id: "", slabs_sold: "", width: "", height: "", area_sold: "", price_per_m2: "", total_price: "" },
    ],
    payment_amount: "",
    payment_method: "cash",
    payment_voucher: "",
    discount_type: "amount",
    discount_value: "",
  }));

  const [invoiceModal, setInvoiceModal] = useState({ open: false, invoice: null });
  const [returnModal, setReturnModal] = useState({ open: false, sale: null });
  const [deletedSale, setDeletedSale] = useState(null);
  const undoTimer = useRef(null);
  const [isDeletingId, setIsDeletingId] = useState(null);

  useEffect(() => {
    fetchAll();
    return () => clearTimeout(undoTimer.current);
    // eslint-disable-next-line
  }, []);

  async function fetchAll() {
    const showroomId = Number(user.showroom_id);

    const [
      { data: salesData },
      { data: saleDetailsData },
      { data: blocksData },
      { data: bdData },
      { data: customersData },
      { data: materialsData },
      { data: reservationsData, error: reservationError },
    ] = await Promise.all([
      supabase.from("sale").select("*").eq("showroom_id", showroomId).order("id", { ascending: false }),
      supabase.from("sale_details").select("*"),
      supabase.from("block").select("*"),
      supabase.from("block_distribution").select("*"),
      supabase.from("customer").select("*"),
      supabase.from("material").select("*"),
      supabase.from("reservation").select("*"),
    ]);

    setSales(salesData || []);
    setSaleDetails(saleDetailsData || []);
    setBlocks(blocksData || []);
    setBlockDistributions(bdData || []);
    setCustomers(customersData || []);
    setMaterials(materialsData || []);
    setReservations(reservationsData || []);
    setStockError(reservationError ? "Unable to load reservations. Refresh the data before selling." : "");

    try {
      const returnsData = await fetchReturnsForShowroom(showroomId);
      setReturns(returnsData || []);
    } catch (e) {
      console.error("fetchReturnsForShowroom", e);
      setReturns([]);
    }
  }

  /* ---------- اختيار كود بالمتغيرات (كما هو) ---------- */
  function codeWithVariantForDetail(detail) {
    const block = blocks.find(b => b.id === detail.block_id);
    const dist  = blockDistributions.find(x => x.id === detail.distribution_id);
    const base  = block?.code || detail.block_id;
    if (!dist) return base;
    const suffix =
      (dist.variant_suffix && dist.variant_suffix.trim()) ||
      ((dist.face_treatment !== 'none' || dist.back_treatment !== 'none' || dist.is_polished)
        ? `${TREAT_MAP[dist.face_treatment || 'none']}/${TREAT_MAP[dist.back_treatment || 'none']}${dist.is_polished ? " + Polished" : ""}`
        : "");
    return suffix ? `${base} - ${suffix}` : base;
  }
  function codeWithVariant(block_id, distribution_id) {
    const block = blocks.find(b => b.id === Number(block_id));
    const dist  = blockDistributions.find(x => x.id === Number(distribution_id));
    const base  = block?.code || block_id;
    if (!dist) return base;
    const suffix =
      (dist.variant_suffix && dist.variant_suffix.trim()) ||
      ((dist.face_treatment !== 'none' || dist.back_treatment !== 'none' || dist.is_polished)
        ? `${TREAT_MAP[dist.face_treatment || 'none']}/${TREAT_MAP[dist.back_treatment || 'none']}${dist.is_polished ? " + Polished" : ""}`
        : "");
    return suffix ? `${base} - ${suffix}` : base;
  }

  /* ---------- حذف بيع (كما هو) ---------- */
  async function clientSideDelete(sale) {
    const { data: details, error: detErr } = await supabase
      .from("sale_details")
      .select("block_id, distribution_id, slabs_sold")
      .eq("sale_id", sale.id);
    if (detErr) throw detErr;

    for (const d of (details || [])) {
      if (d.distribution_id) {
        const { data: dist, error: distErr } = await supabase
          .from("block_distribution")
          .select("id, slabs_count")
          .eq("id", d.distribution_id)
          .single();
        if (distErr) throw distErr;

        if (dist) {
          await supabase
            .from("block_distribution")
            .update({ slabs_count: roundQuantity(Number(dist.slabs_count) + Number(d.slabs_sold)) })
            .eq("id", dist.id);
        }
      } else {
        const { data: distRows, error: e2 } = await supabase
          .from("block_distribution")
          .select("id, slabs_count")
          .eq("block_id", d.block_id)
          .eq("showroom_id", Number(user.showroom_id));
        if (e2) throw e2;
        const dist = distRows?.[0];
        if (dist) {
          await supabase
            .from("block_distribution")
            .update({ slabs_count: roundQuantity(Number(dist.slabs_count) + Number(d.slabs_sold)) })
            .eq("id", dist.id);
        } else {
          await supabase.from("block_distribution").insert([{
            block_id: d.block_id,
            showroom_id: Number(user.showroom_id),
            slabs_count: Number(d.slabs_sold),
            face_treatment: "none",
            back_treatment: "none",
            is_polished: false,
          }]);
        }
      }
    }

    await supabase.from("payment").delete().eq("sale_id", sale.id);
    await supabase.from("sale_details").delete().eq("sale_id", sale.id);
    await supabase.from("sale").delete().eq("id", sale.id);
  }

  async function handleDeleteSale(sale) {
    if (!window.confirm(`Delete sale number ${sale.id}?`)) return;
    setIsDeletingId(sale.id);
    try {
      const { data, error } = await supabase.rpc("delete_sale_tx", {
        p_sale_id: sale.id,
        p_showroom_id: Number(user.showroom_id),
      });

      if (error) {
        if (
          String(englishError(error.message) || "").includes("does not exist") ||
          String(englishError(error.message) || "").includes("permission denied")
        ) {
          await clientSideDelete(sale);
        } else {
          throw error;
        }
      } else if (data !== true) {
        await clientSideDelete(sale);
      }

      await fetchAll();
    } catch (e) {
      console.error("handleDeleteSale:", e);
      alert("Unable to delete: " + (e?.message || e));
    } finally {
      setIsDeletingId(null);
    }
  }

  /* ---------- التوافر حسب المنتج داخل الصالة ---------- */
  function getBlockOptionsForMaterial(materialId) {
    const relevant = blockDistributions.filter(
      (d) => Number(d.showroom_id) === Number(user.showroom_id) && Number(d.slabs_count) > 0
    );
    const totals = {};
    for (const dist of relevant) {
      const blk = blocks.find((b) => b.id === dist.block_id);
      if (!blk || String(blk.material_id) !== String(materialId || "")) continue;
      totals[dist.block_id] = (totals[dist.block_id] || 0) + availableQuantity(dist, reservations, reservationId || null);
    }
    return Object.entries(totals).map(([blockId, totalSlabs]) => {
      const blk = blocks.find((b) => b.id === Number(blockId));
      return {
        block_id: Number(blockId),
        code: blk?.code || blockId,
        material_id: blk?.material_id,
        width: blk?.width,
        height: blk?.height,
        totalSlabs,
        productType: PRODUCT_TYPES[blk?.product_type || "slab"],
      };
    }).filter((option) => option.totalSlabs > 0);
  }

  function pickDistributionIdForBlock(blockId) {
    const dist = blockDistributions
      .filter(
        (d) =>
          Number(d.showroom_id) === Number(user.showroom_id) &&
          Number(d.block_id) === Number(blockId) &&
          availableQuantity(d, reservations, reservationId || null) > 0
      )
      .sort((a, b) => availableQuantity(b, reservations, reservationId || null) - availableQuantity(a, reservations, reservationId || null))[0];
    return dist?.id || null;
  }

  function addRow() {
    setForm((f) => ({
      ...f,
      rows: [
        ...f.rows,
        { material_id: "", block_id: "", slabs_sold: "", width: "", height: "", area_sold: "", price_per_m2: "", total_price: "" },
      ],
    }));
  }
  function removeRow(idx) {
    setForm((f) => ({ ...f, rows: f.rows.filter((_, i) => i !== idx) }));
  }
  function handleRowChange(idx, field, value) {
    setForm((f) => {
      const rows = [...f.rows];
      let next = { ...rows[idx], [field]: value };

      if (field === "material_id") {
        next.block_id = "";
        next.distribution_id = "";
        next.width = "";
        next.height = "";
        next.area_sold = "";
        next.total_price = "";
        next.size_groups = undefined;
      }

      if (field === "block_id") {
        next.size_groups = undefined;
        next.distribution_id = pickDistributionIdForBlock(value) || "";
        const block = blocks.find((b) => Number(b.id) === Number(value));
        if (block) {
          next.material_id = block.material_id ?? next.material_id;
          next.width = block.width ?? next.width ?? "";
          next.height = block.height ?? next.height ?? "";
          next.price_per_m2 = block.sale_price_per_m2 ?? "";
        }
      }

      if (["slabs_sold", "width", "height", "price_per_m2", "block_id"].includes(field)) {
        next = calculateSaleRow(next);
      }
      rows[idx] = next;
      return { ...f, rows };
    });
  }

  function changeSizeGroups(index, change) {
    setForm(current => ({...current,rows:current.rows.map((row,i) => i === index ? calculateSaleRow(change(row)) : row)}));
  }

  /* ---------- إجماليات اللايف (كما هو) ---------- */
  const formSummary = React.useMemo(() => {
    let totalSlabs = 0, totalArea = 0, gross = 0;
    const perBlockArea = {};
    (form.rows || []).forEach(r => {
      const slabs = Number(r.slabs_sold || 0);
      const area  = Number(r.area_sold   || 0);
      const lineTotal = Number(r.total_price || 0);
      totalSlabs = roundQuantity(totalSlabs + slabs);
      totalArea  += area;
      gross      += lineTotal;
      if (r.block_id) {
        const label = blocks.find((b) => b.id === Number(r.block_id))?.code || r.block_id;
        perBlockArea[label] = (perBlockArea[label] || 0) + area;
      }
    });
    let discountAmount = 0;
    if (form.discount_value !== "" && form.discount_value != null) {
      if (form.discount_type === "percent") {
        const pct = Math.max(0, Number(form.discount_value) || 0);
        discountAmount = gross * (pct / 100);
      } else {
        discountAmount = Math.max(0, Number(form.discount_value) || 0);
      }
    }
    discountAmount = Math.min(discountAmount, gross);
    const net = Math.max(0, gross - discountAmount);
    return { totalSlabs, totalArea, gross, discountAmount, net, perBlockArea };
  }, [form.rows, form.discount_type, form.discount_value, blocks, blockDistributions]);

  /* ---------- اختيار/بحث العميل بالهاتف ---------- */
  function findCustomerByPhoneLocal(input) {
    const norm = normalizePhone(input);
    if (!norm) return null;
    const match = (customers || []).find((c) => normalizePhone(c.phone) === norm);
    return match || null;
  }

  function handlePhoneInput(val) {
    setPhoneSearch(val);
    if (!val) {
      setMatchedCustomer(null);
      // ما نغيرش اختيار القائمة إلا لو كان تابع للبحث سابقًا
      return;
    }
    const found = findCustomerByPhoneLocal(val);
    if (found) {
      setMatchedCustomer(found);
      // نثبّت اختيار العميل في الفورم
      setForm((f) => ({ ...f, customer_id: String(found.id) }));
    } else {
      setMatchedCustomer(null);
      // ما نعتمدش عميل في الفورم
      setForm((f) => ({ ...f, customer_id: "" }));
    }
  }

  function handlePickCustomerFromSelect(idStr) {
    setForm((f) => ({ ...f, customer_id: idStr }));
    if (!idStr) {
      setMatchedCustomer(null);
      return;
    }
    const picked = customers.find((c) => String(c.id) === String(idStr));
    setMatchedCustomer(picked ? picked : null);
    setPhoneSearch(picked?.phone || "");
  }

  /* ---------- حفظ البيع ---------- */
  function selectReservation(id) {
    setReservationId(id);
    if (!id) {
      setForm((current) => ({ ...current, rows: [{ material_id: "", block_id: "", distribution_id: "", slabs_sold: "", width: "", height: "", area_sold: "", price_per_m2: "", total_price: "" }] }));
      return;
    }
    const booking = reservations.find((row) => String(row.id) === String(id));
    const distribution = blockDistributions.find((row) => String(row.id) === String(booking?.distribution_id));
    const product = blocks.find((row) => String(row.id) === String(distribution?.block_id));
    if (!booking || !distribution || !product) return;
    setForm((current) => ({ ...current, customer_id: String(booking.customer_id), rows: [calculateSaleRow({
      material_id: product.material_id, block_id: product.id, distribution_id: distribution.id,
      slabs_sold: booking.slabs_reserved, width: product.width || "", height: product.height || "",
      price_per_m2: product.sale_price_per_m2 ?? "",
    })] }));
    const customer = customers.find((row) => String(row.id) === String(booking.customer_id));
    setPhoneSearch(customer?.phone || ""); setMatchedCustomer(customer || null);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (savingRef.current) return;
    if (stockError) return alert(stockError);
    const dateError = saleDateError(form.date);
    if (dateError) return alert(dateError);

    // لازم يكون في عميل محدد سواء من القائمة أو من رقم هاتف موجود
    if (!form.customer_id) {
      return alert("Select a customer or enter a registered customer's phone number.");
    }

    if (
      !form.rows.length ||
      form.rows.some(
        (r) =>
          !r.material_id ||
          !r.block_id ||
          !r.slabs_sold ||
          !r.price_per_m2
      )
    ) {
      return alert("Complete all line details (Material/Product/Slab count/Width/Height/Price).");
    }
    if (!user.showroom_id) return alert("Error: No showroom selected.");
    for (let index = 0; index < form.rows.length; index++) {
      const sizeError = validateSaleSizes(form.rows[index]);
      if (sizeError) return alert(`Item ${index + 1}: ${sizeError}`);
    }
    if (form.rows.some((row) => !validMarbleQuantity(row.slabs_sold) ||
      !Number.isFinite(Number(row.price_per_m2)) || Number(row.price_per_m2) <= 0)) {
      return alert("Enter a positive quantity with up to three decimal places, and positive dimensions and price per square metre.");
    }
    if (form.payment_amount !== "" && (!Number.isFinite(Number(form.payment_amount)) || Number(form.payment_amount) < 0 || Number(form.payment_amount) > formSummary.net)) {
      return alert("Payment must not exceed the invoice net total.");
    }

    const items = saleSizeItems(form.rows, pickDistributionIdForBlock);

    if (items.some((it) => !it.distribution_id)) {
      return alert("No available stock for this product in this showroom.");
    }

    savingRef.current = true; setSaving(true);
    try {
    const [stockResult, bookingResult] = await Promise.all([
      supabase.from("block_distribution").select("*").eq("showroom_id", user.showroom_id),
      supabase.from("reservation").select("*"),
    ]);
    if (stockResult.error || bookingResult.error) throw stockResult.error || bookingResult.error;
    const stock = stockResult.data || [];
    const bookings = bookingResult.data || [];
    if (items.some((item) => !stock.some((dist) => String(dist.id) === String(item.distribution_id) && String(dist.block_id) === String(item.block_id)))) {
      return alert("Select stock from the current showroom.");
    }
    if (reservationId) {
      const booking = bookings.find((row) => String(row.id) === String(reservationId));
      if (!booking || reservationStatus(booking) !== "active" || String(booking.customer_id) !== String(form.customer_id) ||
        items.some(item => String(item.distribution_id) !== String(booking.distribution_id)) ||
        sumQuantities(items.map(item => item.slabs_sold)) !== Number(booking.slabs_reserved)) {
        return alert("The reservation has changed or expired. Refresh and select the reservation again.");
      }
    }
    const stockValidation = validateSaleStock(items, stock, bookings, reservationId || null);
    if (stockValidation) return alert(stockValidation);

    const { data: saleId, error } = await supabase.rpc("create_dated_marble_sale_tx", {
      p_date: form.date,
      p_reservation_id: reservationId ? Number(reservationId) : null,
      p_showroom_id: Number(user.showroom_id),
      p_customer_id: Number(form.customer_id),
      p_items: items,
      p_discount_type: form.discount_value !== "" ? form.discount_type : null,
      p_discount_value: form.discount_value !== "" ? Number(form.discount_value) : null,
      p_payment_amount: form.payment_amount !== "" ? Number(form.payment_amount) : null,
      p_payment_method: form.payment_amount !== "" ? (form.payment_method || 'cash') : null,
      p_payment_voucher: form.payment_amount !== "" ? (form.payment_voucher || null) : null
    });

    if (error) {
      if (/INSUFFICIENT_STOCK_OR_MISSING_DISTRIBUTION|RESERVED_STOCK|INSUFFICIENT_AVAILABLE_STOCK/.test(String(englishError(error.message) || ""))) {
        return alert("Insufficient stock or the Variant does not exist in this showroom.");
      }
      return alert("Unable to save: " + englishError(error.message));
    }

    if (!onSaleSaved) alert(`Sale saved! Invoice number: ${saleId}`);
    setShowForm(false);
    setForm({
      customer_id: "",
      date: businessDate(),
      rows: [{ material_id: "", block_id: "", slabs_sold: "", width: "", height: "", area_sold: "", price_per_m2: "", total_price: "" }],
      payment_amount: "",
      discount_type: "amount",
      discount_value: "",
      payment_method: "cash",
      payment_voucher: ""
    });
    setPhoneSearch("");
    setMatchedCustomer(null);
    setReservationId("");
    if (onSaleSaved) await onSaleSaved({ saleId, date: form.date, showroomId: Number(user.showroom_id) });
    else await fetchAll();
    } catch (err) { alert("Unable to save sale: " + englishError(err.message)); }
    finally { savingRef.current = false; setSaving(false); }
  }

  /* ---------- باقي الدوال: عرض الفاتورة، المرتجع، الإجماليات ... (كما هي) ---------- */
  async function openInvoiceModal(sale) {
    const sDetails = saleDetails
      .filter((d) => d.sale_id === sale.id)
      .map((d) => {
        const block = blocks.find((b) => b.id === d.block_id);
        const mat = materials.find((m) => m.id === block?.material_id);
        return {
          ...d,
          block_code: codeWithVariantForDetail(d),
          material_name: mat?.name || mat?.material_name || "-",
        };
      });
    const { data: payments } = await supabase.from("payment").select("*").eq("sale_id", sale.id);
    setInvoiceModal({
      open: true,
      invoice: {
        sale,
        saleDetails: sDetails,
        customer: customers.find((c) => c.id === sale.customer_id),
        payments: payments || [],
      },
    });
  }

  function handleOpenReturnModal(sale) {
    setReturnModal({ open: true, sale });
  }

  function saleTotal(sale) {
    const details = saleDetails.filter((d) => d.sale_id === sale.id);
    const gross = details.reduce((a, d) => a + Number(d.total_price || 0), 0);
    if (sale.net_total != null && sale.net_total !== "") {
      return Number(sale.net_total);
    }
    let discount = 0;
    if (sale.discount_type && sale.discount_value != null && sale.discount_value !== "") {
      if (sale.discount_type === "amount") discount = Number(sale.discount_value) || 0;
      else if (sale.discount_type === "percent") {
        const pct = Number(sale.discount_value) || 0;
        discount = gross * (pct / 100);
      }
    }
    const net = Math.max(0, gross - discount);
    return net;
  }

  async function handlePrintReturn(returnId) {
    try {
      const data = await getReturnNoteById(returnId);
      const html = `
        <html dir="ltr" lang="ar">
          <head>
            <meta charset="utf-8" />
            <title>Return invoice #${data.id} — For invoice ${data.original_sale_id}</title>
            <style>
              body { font-family: Jost, 'Trebuchet MS', Arial, sans-serif; direction: ltr; padding: 20px; }
              h2 { text-align: center; color: #514536; margin: 0 0 10px; }
              table { width: 100%; border-collapse: collapse; margin-top: 12px; }
              th, td { border: 1px solid #d2cbc1; padding: 6px 8px; text-align: center; }
              tfoot td { font-weight: bold; }
            </style>
          </head>
          <body>
            <h2>Return invoice (Credit note)</h2>
            <div>Original invoice: <b>${data.original_sale_id}</b></div>
            <div>Date: ${new Date(data.date).toLocaleDateString("en-GB")}</div>
            <div>Customer: ${data.customer?.name || ""} ${data.customer?.phone ? "— " + data.customer.phone : ""}</div>
            <div>Reason: ${data.reason || "-"}</div>
            <table>
              <thead>
                <tr>
                  <th>Sale code</th>
                  <th>Product code</th>
                  <th>Showroom</th>
                  <th>Returned slabs</th>
                  <th>Returned area (m²)</th>
                  <th>Price per square metre</th>
                  <th>Total </th>
                </tr>
              </thead>
              <tbody>
                ${(data.details || [])
                  .map(
                    (d) => `
                  <tr>
                    <td>${d.sale_detail_id}</td>
                    <td>${d.block_id}</td>
                    <td>${d.showroom_id}</td>
                    <td>${d.slabs_returned}</td>
                    <td>${Number(d.area_returned_m2).toFixed(3)}</td>
                    <td>${Number(d.price_per_m2).toFixed(2)}</td>
                    <td>${(Number(d.area_returned_m2) * Number(d.price_per_m2)).toFixed(2)}</td>
                  </tr>
                `
                  )
                  .join("")}
              </tbody>
              <tfoot>
                <tr><td colspan="6">Total</td><td>${Number(data.total_refund).toFixed(2)}</td></tr>
              </tfoot>
            </table>
          </body>
        </html>
      `;
      const win = window.open("", "_blank");
      if (win && win.document) {
        win.document.open();
        win.document.write(html);
        win.document.close();
        printWithTheme(win);
        win.focus();
      }
    } catch (e) {
      alert(englishError(e.message) || "Unable to print return");
    }
  }

  /* ---------- واجهة المستخدم ---------- */
  const totalSales = sales.reduce((sum, s) => sum + saleTotal(s), 0);
  const totalReturns = returns.reduce((sum, r) => sum + Number(r.total_refund_for_showroom || 0), 0);
  const netTotal = totalSales - totalReturns;

  const formatMoney = value => Number(value || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <div className="marble-sales" dir="ltr">
      {!formOnly && <>
      <header className="ms-page-heading"><h2>Sales and returns</h2><div className="ms-header-actions">
        <button type="button" className="ms-secondary" onClick={fetchAll} disabled={saving}>Refresh data</button>
        <button type="button" className="ms-primary" onClick={() => { setForm(current => ({ ...current, date: businessDate() })); setShowForm(true); }} disabled={saving}>New sale</button>
      </div></header>
      {stockError && <p role="alert">{stockError}</p>}
      <div className="ms-metrics">
        {[["Sales after discount",totalSales],["Returns",totalReturns],["Net sales",netTotal]].map(([label,value]) => <div key={label}><span>{label}</span><strong>{formatMoney(value)} EGP</strong></div>)}
      </div>

      <section className="ms-card">
        <div className="ms-section-heading"><h3>Sales records</h3><span>{sales.length} invoice{sales.length === 1 ? "" : "s"}</span></div>
        <div className="ms-table-scroll"><table>
          <thead><tr>{["No.","Customer","Sale details","Total after discount (EGP)","Date","Actions"].map(label => <th key={label}>{label}</th>)}</tr></thead>
          <tbody>
            {sales.map((sale,i) => {
              const customerName = customers.find(c => c.id === sale.customer_id)?.name || "";
              const details = saleDetails.filter(d => d.sale_id === sale.id);
              return <tr key={sale.id}><td>{i+1}</td><td>{customerName}</td><td className="ms-detail-cell">
                {details.length === 0 ? "-" : details.map((d,j) => {
                  const block = blocks.find(b => b.id === d.block_id);
                  const mat = materials.find(m => m.id === block?.material_id);
                  return <div className="ms-item-description" key={j}><strong>Code: {codeWithVariantForDetail(d)}</strong><span>{mat?.name || mat?.material_name || "-"} · {saleSizeLabel(d.width,d.height)} · {d.area_sold} m² · {d.slabs_sold} pieces</span></div>;
                })}
              </td><td className="ms-number">{formatMoney(saleTotal(sale))}</td><td className="ms-date">{sale.date?.split("T")[0]}</td><td>
                <div className="ms-row-actions"><button type="button" className="ms-primary" onClick={() => openInvoiceModal(sale)}>View / Print invoice</button>
                  <button type="button" className="ms-secondary" onClick={() => handleOpenReturnModal(sale)}>Return</button>
                  <button type="button" className="ms-secondary" disabled={isDeletingId === sale.id} onClick={() => handleDeleteSale(sale)}>{isDeletingId === sale.id ? "Deleting…" : "Delete"}</button>
                </div>
              </td></tr>;
            })}
            {!sales.length && <tr><td colSpan={6} className="ms-empty">No sales yet</td></tr>}
          </tbody>
        </table></div>
      </section>

      <section className="ms-card">
        <div className="ms-section-heading"><h3>Return records</h3><span>{returns.length} return{returns.length === 1 ? "" : "s"}</span></div>
        <div className="ms-table-scroll"><table>
          <thead><tr>{["No.","Customer","Original invoice number","Return value (EGP)","Date","Actions"].map(label => <th key={label}>{label}</th>)}</tr></thead>
          <tbody>{returns.map((r,i) => {
            const customerName = customers.find(c => c.id === r.customer_id)?.name || "";
            return <tr key={r.id}><td>{i+1}</td><td>{customerName}</td><td>{r.original_sale_id || "-"}</td><td className="ms-number">-{formatMoney(r.total_refund_for_showroom)}</td><td className="ms-date">{r.date?.split("T")[0]}</td><td><div className="ms-row-actions"><button type="button" className="ms-primary" onClick={() => handlePrintReturn(r.id)}>Print return</button></div></td></tr>;
          })}
          {!returns.length && <tr><td colSpan={6} className="ms-empty">No returns yet</td></tr>}
          </tbody>
        </table></div>
      </section>

      </>}
      {showForm && <div className="ms-modal-backdrop"><div className="ms-sale-modal" role="dialog" aria-modal="true" aria-labelledby="ms-sale-title">
        <h3 id="ms-sale-title">New sale</h3>
        {formOnly && stockError && <p role="alert">{stockError}</p>}
        <form onSubmit={handleSubmit}><fieldset disabled={saving}>
          <div className="ms-customer-fields">
            <label>Sale date<input type="date" required max={businessDate()} value={form.date} onChange={event => setForm(current => ({ ...current, date: event.target.value }))} /></label>
            <div className="ms-field"><label htmlFor="ms-transaction">Transaction type</label><select id="ms-transaction" value={reservationId} onChange={event => selectReservation(event.target.value)}>
              <option value="">Sell available stock</option>
              {reservations.filter(booking => reservationStatus(booking) === "active" && blockDistributions.some(dist => String(dist.id) === String(booking.distribution_id) && String(dist.showroom_id) === String(user.showroom_id))).map(booking => <option key={booking.id} value={booking.id}>Reservation #{booking.id} · {customers.find(row => String(row.id) === String(booking.customer_id))?.name} · {booking.slabs_reserved} pieces</option>)}
            </select></div>
            <div className="ms-field"><label htmlFor="ms-customer">Customer</label><div className="ms-customer-picker"><select id="ms-customer" value={form.customer_id} disabled={!!reservationId} onChange={e => handlePickCustomerFromSelect(e.target.value)}>
              <option value="">Select a customer</option>{customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select><button type="button" className="ms-secondary" onClick={() => setShowAddCustomer(true)}>New customer</button></div></div>
            <label>Customer phone<input dir="ltr" value={phoneSearch} disabled={!!reservationId} onChange={e => handlePhoneInput(e.target.value)} /></label>
          </div>
          {phoneSearch && matchedCustomer && <p>Customer found: {matchedCustomer.name}</p>}
          {phoneSearch && !matchedCustomer && <div className="ms-phone-result"><span>No customer is registered with this number.</span><button type="button" className="ms-secondary" onClick={() => setShowAddCustomer(true)}>Add customer</button></div>}

          <div className="ms-section-heading"><h4>Line items</h4>{!reservationId && <button type="button" className="ms-secondary" onClick={addRow}>Add another line</button>}</div>
          {form.rows.map((row,idx) => {
            const product = blocks.find(block => String(block.id) === String(row.block_id));
            const countLabel = stockCountLabel(product?.product_type);
            const unit = stockCountUnit(product?.product_type);
            const forecast = saleStockForecast(row.distribution_id,form.rows,blockDistributions,reservations,reservationId || null);
            const count = value => Number(value).toLocaleString("en-GB",{maximumFractionDigits:3});
            const countText = value => `${count(value)} ${Math.abs(Number(value)) === 1 ? unit.slice(0,-1) : unit}`;
            return <article className="ms-line" key={idx}>
            <div className="ms-section-heading"><h4>Item {idx+1}</h4>{form.rows.length > 1 && <button type="button" className="ms-secondary" onClick={() => removeRow(idx)}>Remove line</button>}</div>
            <div className="ms-line-fields">
              <div className="ms-field"><label htmlFor={`ms-material-${idx}`}>Material</label><select id={`ms-material-${idx}`} value={row.material_id} disabled={!!reservationId} onChange={e => handleRowChange(idx,"material_id",e.target.value)} required>
                <option value="">Select a material</option>{materials.map(m => <option key={m.id} value={m.id}>{m.name || m.material_name}</option>)}
              </select></div>
              <div className="ms-field"><label htmlFor={`ms-product-${idx}`}>Product</label><select id={`ms-product-${idx}`} value={row.block_id} disabled={!!reservationId} onChange={e => handleRowChange(idx,"block_id",e.target.value)} required>
                <option value="">Select a product</option>{getBlockOptionsForMaterial(row.material_id).map(opt => <option key={opt.block_id} value={opt.block_id}>{opt.code} · {opt.productType} · {saleSizeLabel(opt.width,opt.height)} — {opt.totalSlabs} pieces available</option>)}
              </select></div>
              <div className="ms-field"><label htmlFor={`ms-finish-${idx}`}>Product stock / Finish</label><select id={`ms-finish-${idx}`} value={row.distribution_id || ""} disabled={!!reservationId} onChange={e => handleRowChange(idx,"distribution_id",e.target.value)} required>
                <option value="">Select a finish</option>{blockDistributions.filter(dist => String(dist.block_id) === String(row.block_id) && String(dist.showroom_id) === String(user.showroom_id)).map(dist => <option key={dist.id} value={dist.id} disabled={availableQuantity(dist,reservations,reservationId || null) <= 0}>
                  {dist.variant_suffix || `${TREAT_MAP[dist.face_treatment || "none"]}/${TREAT_MAP[dist.back_treatment || "none"]}${dist.is_polished ? " · Polished" : ""}`} — {availableQuantity(dist,reservations,reservationId || null)} {unit} available
                </option>)}
              </select></div>
              {[["slabs_sold",countLabel,0.001,"0.001",!!reservationId,true],["width","Width (m)",0.001,"0.001",false,true],["height","Length (m)",0.001,"0.001",false,true],["area_sold","Area (m²)",undefined,undefined,true,false],["price_per_m2","Price per m² (EGP)",undefined,"0.01",false,true],["total_price","Line total (EGP)",undefined,undefined,true,false]].filter(([field]) => !row.size_groups || !["width","height"].includes(field)).map(([field,label,min,step,readOnly,required]) => <label key={field}>{label}<input type="number" min={min} step={step} readOnly={readOnly} required={required} value={row[field]} onChange={readOnly ? undefined : e => handleRowChange(idx,field,e.target.value)} /></label>)}
            </div>
            {forecast && <div className={`ms-stock-forecast${forecast.after < forecast.reserved ? " ms-stock-insufficient" : ""}`} role="status">
              <span>Stock now: <strong>{countText(forecast.current)}</strong></span>
              <span>Selling: <strong>{countText(forecast.selling)}</strong></span>
              <span>Stock after sale: <strong>{countText(forecast.after)}</strong></span>
              {forecast.reserved > 0 && <span>Reserved: {countText(forecast.reserved)}</span>}
            </div>}
            <div className="ms-size-controls">
              <button type="button" className="ms-secondary" disabled={!row.block_id || !validMarbleQuantity(row.slabs_sold)} onClick={() => changeSizeGroups(idx,current => current.size_groups
                ? {...current,width:current.size_groups[0].width,height:current.size_groups[0].height,size_groups:undefined}
                : {...current,size_groups:[{slabs_sold:current.slabs_sold,width:current.width,height:current.height},{slabs_sold:"",width:current.width,height:current.height}]})}>{row.size_groups ? "Use one size" : "Split by size"}</button>
            </div>
            {row.size_groups && <section className="ms-size-groups" aria-label={`Item ${idx+1} sizes`}>
              <div className="ms-section-heading"><h4>Sizes</h4><button type="button" className="ms-secondary" onClick={() => changeSizeGroups(idx,current => ({...current,size_groups:[...current.size_groups,{slabs_sold:"",width:current.width,height:current.height}]}))}>Add size</button></div>
              {row.size_groups.map((group,sizeIndex) => {
                const totals = saleSizeTotals(group,row.price_per_m2);
                return <div className="ms-size-group" key={sizeIndex} role="group" aria-label={`Size ${sizeIndex+1}`}>
                  <div className="ms-section-heading"><h5>Size {sizeIndex+1}</h5>{row.size_groups.length > 1 && <button type="button" className="ms-secondary" onClick={() => changeSizeGroups(idx,current => ({...current,size_groups:current.size_groups.filter((_,i) => i !== sizeIndex)}))}>Remove size</button>}</div>
                  <div className="ms-line-fields">{[["slabs_sold",countLabel],["width","Width (m)"],["height","Length (m)"]].map(([field,label]) => <label key={field}>{label}<input type="number" min="0.001" step="0.001" required value={group[field]} onChange={event => {
                    const value = event.target.value;
                    changeSizeGroups(idx,current => ({...current,size_groups:current.size_groups.map((size,i) => i === sizeIndex ? {...size,[field]:value} : size)}));
                  }} /></label>)}</div>
                  <p className="ms-size-total">Area: {totals.area.toFixed(3)} m² · Total: {formatMoney(totals.total)} EGP</p>
                </div>;
              })}
              <p className="ms-size-balance" role="status">Allocated: {sumQuantities(row.size_groups.map(group => group.slabs_sold))} of {row.slabs_sold} {unit}{sumQuantities(row.size_groups.map(group => group.slabs_sold)) !== Number(row.slabs_sold) ? " — quantities must match before saving." : ""}</p>
            </section>}
          </article>;})}

          <div className="ms-form-summary">
            <span>Total slab/piece count: {formSummary.totalSlabs.toLocaleString()}</span><span>Total area: {formSummary.totalArea.toLocaleString(undefined,{ maximumFractionDigits: 3 })} m²</span>
            <span>Before discount: {formatMoney(formSummary.gross)} EGP</span>{formSummary.discountAmount > 0 && <span>Discount: -{formatMoney(formSummary.discountAmount)} EGP</span>}<strong>Net: {formatMoney(formSummary.net)} EGP</strong>
          </div>
          <div className="ms-settlement">
            <label>{form.discount_type === "percent" ? "Discount (%)" : "Discount (EGP)"}<input type="number" min={0} step="0.01" value={form.discount_value} onChange={e => setForm(f => ({...f,discount_value:e.target.value}))} /></label>
            <label>Initial payment (EGP)<input type="number" min={0} value={form.payment_amount} onChange={e => setForm(f => ({...f,payment_amount:e.target.value}))} /></label>
            <div className="ms-field"><label htmlFor="ms-payment-method">Payment method</label><select id="ms-payment-method" value={form.payment_method} onChange={e => setForm(f => ({...f,payment_method:e.target.value}))}><option value="cash">Cash</option><option value="vodafone">Vodafone Cash</option><option value="insta">InstaPay</option><option value="cheque">Cheque</option><option value="bank">Bank transfer</option></select></div>
            <label>Voucher number<input value={form.payment_voucher} onChange={e => setForm(f => ({...f,payment_voucher:e.target.value}))} /></label>
          </div>
          <div className="ms-form-actions"><button type="button" className="ms-secondary" onClick={() => { setShowForm(false); onCancel?.(); }}>Cancel</button><button type="submit" className="ms-primary">{saving ? "Saving sale…" : "Save sale"}</button></div>
        </fieldset></form>
      </div></div>}

      {showAddCustomer && (
        <SmallAddCustomerPopup
          initialPhone={phoneSearch || ""}
          onSaved={async () => {
            await fetchAll();
            // بعد الإضافة، جرّبي تعيين العميل لو الرقم هو نفسه المكتوب
            if (phoneSearch) {
              const c = findCustomerByPhoneLocal(phoneSearch);
              if (c) setForm((f) => ({ ...f, customer_id: String(c.id) }));
              setMatchedCustomer(c || null);
            }
          }}
          onClose={() => setShowAddCustomer(false)}
        />
      )}

      <InvoiceModal
        open={invoiceModal.open}
        onClose={() => setInvoiceModal({ open: false, invoice: null })}
        invoice={invoiceModal.invoice}
        user={user}
      />

      <ReturnNoteModal
        open={returnModal.open}
        onClose={(shouldRefresh) => {
          setReturnModal({ open: false, sale: null });
          if (shouldRefresh) fetchAll();
        }}
        sale={returnModal.sale}
      />
    </div>
  );
}

export default SalesTable;
